import styled from 'styled-components';
import { Card } from '../styled';

export const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

export const CardSeason4 = styled(Card)`
    background-size: 80px auto, cover;
    background-position: calc(100% - 60px) center, 100% 100%;
`;

export const Season1Empty = styled.div`
    width: 100%;
    border: 1px solid #323232;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const WarningIcon = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #323232;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;

    &::after {
        content: '!';
        color: #000;
        font-size: 16px;
        font-weight: 700;
        line-height: 1;
    }
`;

export const PointsTag = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    padding: 4px;
    background: #5fd15c;
    color: #000;
    border-radius: 8px;
    gap: 4px;
`;

export const StyledQuestionIcon = styled.div`
    width: 12px;
    height: 12px;
    cursor: pointer;
    margin-left: 4px;
`;